// Emergency mode's screens (PMU-273, E3): in the staff app the band around every screen, the
// Emergency page and the way in from Now. On the door, the whole screen.
import type { UiPart } from "@vavr/screens/shared";
import { DoorEmergency, EmergencyBanner, EmergencyBar, EmergencyScreen } from "./staff.tsx";

export const emergencyUi: UiPart = {
  id: "emergency",
  slots: {
    "staff.wrap": [{ id: "emergency", wrap: (children) => <EmergencyBanner>{children}</EmergencyBanner> }],
    "staff.page": [{ id: "emergency", path: "emergency", title: "Emergency", tab: "now", full: true, render: () => <EmergencyScreen /> }],
    "staff.footer": [{ id: "emergency", tabs: ["now"], render: () => <EmergencyBar /> }],
    "kiosk.wrap": [{ id: "emergency", wrap: (children) => <DoorEmergency>{children}</DoorEmergency> }],
  },
};
